import { baseApi } from '@/services/index';

const resource = process.env.VUE_APP_RESOURCE_SICUD_SUBIR_DOC;

export default {
  post(payload) {
    return baseApi.post(resource, payload);
  },
};
